import React, { useMemo } from 'react'

// Hooks
import useUserProfile from 'modules/user/useUserProfile'
import { useGetCommunityQuery } from '@sketch/gql-types'

// Components
import {
  DynamicLoadingPage,
  GenericErrorView,
  useQueryParams,
} from '@sketch/modules-common'

// Local Components
import Community from '../containers/Community'
import CommunityHeader from '../components/CommunityHeader'
import CommunityWrapper from '../components/CommunityWrapper'
import CommunityListingHeader from '../components/CommunityListingHeader'
import CommunityPublicationGrid from '../components/CommunityPublicationGrid'

const CommunityHub = () => {
  const { data: userData } = useUserProfile()
  const user = userData?.me

  const {
    data: communityData,
    loading: communityLoading,
    error: communityError,
  } = useGetCommunityQuery()

  if (communityLoading) {
    return <DynamicLoadingPage />
  }

  if (communityError || !communityData) {
    return <GenericErrorView error={communityError} />
  }

  return <Community user={user} data={communityData} />
}

interface CommunitySearchProps {
  search: string
}

const CommunitySearch = ({ search: searchParam }: CommunitySearchProps) => {
  const { data: userData } = useUserProfile()
  const user = userData?.me

  const search = useMemo(() => searchParam, [searchParam])

  return (
    <>
      <CommunityHeader user={user} />
      <CommunityWrapper>
        <CommunityListingHeader title={`Search results for “${search}”`} />
        <CommunityPublicationGrid preferences={{ search }} />
      </CommunityWrapper>
    </>
  )
}

const CommunityView = () => {
  const { search } = useQueryParams<'COMMUNITY_CANVAS'>()

  if (search) {
    return <CommunitySearch search={search} />
  }

  return <CommunityHub />
}

export default CommunityView
